import React from "react";
import { PromoBar } from "../components/PromoBar";
import { Hero } from "../components/Hero";
import { ProblemSection } from "../components/ProblemSection";
import { ValueSection } from "../components/ValueSection";
import { MidOfferSection } from "../components/MidOfferSection";
import { PersonaSection } from "../components/PersonaSection";
import { MethodSection } from "../components/MethodSection";
import { VolumesSection } from "../components/VolumesSection";
import { BonusSection } from "../components/BonusSection";
import { OfferSection } from "../components/OfferSection";
import { GuaranteeSection } from "../components/GuaranteeSection";
import { TestimonialsSection } from "../components/TestimonialsSection";
import { FaqSection } from "../components/FaqSection";
import { ClosingSection } from "../components/ClosingSection";
import { SiteFooter } from "../components/SiteFooter";
export function Landing() {
  return <div className="min-h-screen w-full overflow-x-clip bg-canvas font-sans text-ink" data-id="element-330" data-mp="m7v5mpd8ame4">
      <PromoBar data-id="element-331" data-mp="2atn8xrbotkn" />
      <main data-id="element-332" data-mp="2bblu11gjjvq">
        <Hero data-id="element-333" data-mp="27nv19nedbkp" />
        <ProblemSection data-id="element-334" data-mp="3tgl7jgif5bzj" />
        <ValueSection data-id="element-335" data-mp="3tg1y6o6u3vx4" />
        <MidOfferSection data-id="element-336" data-mp="3terzpxw2klpy" />
        <PersonaSection data-id="element-337" data-mp="3tio7otdaclhz" />
        <MethodSection data-id="element-338" data-mp="3pegeaivvuhdf" />
        <VolumesSection data-id="element-339" data-mp="3pfrk0o8w1z76" />
        <BonusSection data-id="element-340" data-mp="3pezzc8gtxlvo" />
        <OfferSection data-id="element-341" data-mp="3pgkt3vvbl0sh" />
        <GuaranteeSection data-id="element-342" data-mp="3kg6kablw9mte" />
        <TestimonialsSection data-id="element-343" data-mp="3kgomrpz5gx9r" />
        <FaqSection data-id="element-344" data-mp="3khq1q5jae3wr" />
        <ClosingSection data-id="element-345" data-mp="l0ia03l0t3ox" />
      </main>
      <SiteFooter data-id="element-346" data-mp="kzgm2yiwomps" />
    </div>;
}